import styled from 'styled-components'

export const TooltipOverlayUi = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
`
